import { Box, Button, Card, CardContent, Chip, CircularProgress, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Loading from '../../../../components/Loader/Loading';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../../components/pagination/CustomPagination';
import { useForm, Controller } from 'react-hook-form';
import { FormControl, InputAdornment, IconButton, MenuItem, Select, TextField } from '@mui/material';
import { Clear, Download, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TaxService } from '../TaxService';
import ExportAll from './ExportAll'

const TaxReport = (props) => {
    const { } = props;
    const {control,watch,handleSubmit,setValue, formState: { isDirty }} = useForm({
        defaultValues:{
            searchType: 'dateRange',
            year:dayjs().year(),
            startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
            endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
            bookingNumber:'',
        }
    });
    const [loading, setLoading] = useState(false);
    const [taxData, setTaxData] = useState(null);
    const [rows, setRows] = useState([]);
    const [summary, setSummary] = useState(null);
    const columns=[
        { field: 'bookingNumber', headerName: 'Booking No.', width: 180, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Booking No.</span>,
            renderCell: (params) =>(
                <Typography color="primary" sx={{fontSize:'.65rem',cursor:'pointer'}} >
                    {params.value}
                    {/* {' '} */}
                    {/* {params.row.customerId == params.row.createdBy && <PhoneAndroid sx={{fontSize:'.65rem'}} color='warning'/>} */}
                </Typography>
            )
        },
        { field: 'customerName', headerName: 'Customer', width: 150, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Customer</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'state', headerName: 'State', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>State</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}({params.row.stateCode})</Typography>
                </Box>
            )
        },
        { field: 'serviceDate', headerName: 'Service Date', width: 110, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Service Date</span>,
            // valueFormatter: (params) => ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{dayjs(params.value).format('DD-MM-YYYY')}</Typography>
                </Box>
            )
        },
        { field: 'serviceName', headerName: 'Service Name', width: 160, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Service Name</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        // { field: 'chargeType', headerName: 'Charge Type', width: 130, headerAlign: 'left', align: 'left',
        //     renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Charge Type</span>,
        //     renderCell: (params) => (
        //         <Chip 
        //             label={params.value?.replace(/_/g, ' ')} 
        //             size="small" 
        //             sx={{ fontSize: '0.65rem', height: 20 }}
        //             color={params.value === 'SERVICE_ITEM' ? 'primary' : params.value === 'VISITING_CHARGE' ? 'secondary' : 'default'}
        //         />
        //     )
        // },
        { field: 'quantity', headerName: 'Qty', width: 60, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Qty</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex',alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'baseAmount', headerName: 'Base Amt', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Base Amt</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'discount', headerName: 'Discount', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Discount</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{(parseFloat(params.row?.coinDiscount || 0) + parseFloat(params.row?.couponDiscount || 0)).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'taxableAmount', headerName: 'Taxable Amt', width: 100, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Taxable Amt</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'cgst', headerName: 'CGST', width: 80, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>CGST</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'sgst', headerName: 'SGST', width: 80, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>SGST</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            ) 
        },
        { field: 'igst', headerName: 'IGST', width: 80, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>IGST</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'totalGst', headerName: 'Total GST', width: 95, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total GST</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'totalAmount', headerName: 'Total Amt', width: 100, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total Amt</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'taxRate', headerName: 'Tax Rate', width: 60, headerAlign: 'right', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Tax Rate</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}%</Typography>
                </Box>
            )
        },
    ]
    const searchType = watch('searchType');
    const year = watch('year');
    const startDate = watch('startDate');
    const endDate = watch('endDate');
    const bookingNumber = watch('bookingNumber');
    const years = Array.from({ length: 5 }, (_, i) => dayjs().year() - i);
    const handleClear = () => {
        setValue('searchType', 'dateRange');
        setValue('year', dayjs().year());
        setValue('startDate', dayjs().startOf('month').format('YYYY-MM-DD'));
        setValue('endDate', dayjs().endOf('month').format('YYYY-MM-DD'));
        setValue('bookingNumber', '');
        setTaxData(null);
        setRows([]);
        setSummary(null);
        fetchTaxData();
    }
    const submitHandler = (data) => {
        // fetchTaxData();
        console.log(data);
        fetchTaxData();
    }
    const fetchTaxData = async () => {
        setLoading(true);
        setTaxData(null);
        setRows([]);
        setSummary(null);

        try {
            let response;
            if (searchType === 'year') {
                response = await TaxService.getTaxDetailsByYear(year);
            } else if (searchType === 'dateRange') {
                response = await TaxService.getTaxDetailsByTimePeriod(
                    startDate,
                    endDate
                );
            } else if (searchType === 'booking' && bookingNumber.trim()) {
                response = await TaxService.getTaxDetailsByBooking(bookingNumber.trim());
            }

            if (response?.success === 1) {
                setTaxData(response.data);
                if (response.data.rows) {
                    setRows(response.data.rows);
                }
                if (response.data.summary) {
                    setSummary(response.data.summary);
                }
                if (response.data.taxEntries) {
                    setRows(response.data.taxEntries);
                }
                if (response.data.storedTotals) {
                    setSummary({
                        totalBookings: 1,
                        totalTaxableAmount: response.data.computedFromItems?.taxableAmount || response.data.storedTotals.subTotal,
                        totalCouponDiscount: response.data.storedTotals.couponDiscount,
                        totalCoinDiscount: response.data.storedTotals.coinDiscount,
                        totalDiscount: response.data.storedTotals.discount,
                        totalIgst: response.data.computedFromItems?.igst || 0,
                        totalCgst: response.data.computedFromItems?.cgst || 0,
                        totalSgst: response.data.computedFromItems?.sgst || 0,
                        totalGst: response.data.computedFromItems?.totalGst || response.data.storedTotals.totalTax,
                        grandTotal: response.data.computedFromItems?.totalAmount || response.data.storedTotals.grandTotal
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching tax data:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchTaxData();
    }, []);
  return (
    <>
        <Card>
            <Box sx={{ overflow: "auto" }}>
            <Box 
                sx={{ 
                width: "100%", display: "table",  tableLayout: "fixed", 
                backgroundColor: "#fff", borderRadius: '.5rem',
                '& .odd': {
                    bgcolor: 'white',
                },
                '& .even': {
                    bgcolor: '#ECECEC',
                },
                }}>
    
            {loading && <Loading/>}
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',p:'.5% 1%' }}>
                
                    <Box component={'form'} onSubmit={handleSubmit(submitHandler)} flex={1}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Controller
                                    control={control}
                                    name="searchType"
                                    rules={{
                                        required:'select search type',
                                    }}
                                    render={({field,fieldState:{error}})=>(
                                        <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                                            <Select
                                                {...field}
                                                error={!!error}
                                                sx={{
                                                    fontSize:'0.65rem',
                                                }}
                                            >
                                                <MenuItem value="dateRange" sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Date Range</MenuItem>
                                                <MenuItem value="year" sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>By Year</MenuItem>
                                                <MenuItem value="booking" sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>By Booking Number</MenuItem>
                                                {/* <MenuItem value='true' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Eligible</MenuItem>
                                                <MenuItem value='false' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Not Eligible</MenuItem> */}
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            {searchType === 'dateRange' && (
                                <>
                                    <Grid item xs={12} sm={3}>
                                        {/* <DatePicker
                                            label="Start Date"
                                            value={startDate}
                                            onChange={(newValue) => setStartDate(newValue)}
                                            slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                            maxDate={endDate}
                                        /> */}
                                        <Controller
                                            name="startDate"
                                            control={control}
                                            rules={{
                                                // validate: (value) => {
                                                // if (!value) return "This field is required";
                                                // const date = dayjs(value);
                                                // const today = dayjs().startOf('day');
                                                // return date.isValid() && (date.isSame(today, 'day') || date.isAfter(today)) || "Booking Date must be today or in the future";
                                                // }
                                            }}
                                            render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        {...restField}
                                                        sx={{
                                                        '& . iconButton': {
                                                            padding: 0.5,
                                                            fontSize: '1rem'
                                                        }
                                                        }}
                                                        // disabled={!watch('services').length>0 || !watch('customer')}
                                                        value={value ? dayjs(value) : null}
                                                        onChange={(newValue) => {
                                                        // Store the date in YYYY-MM-DD format for database compatibility
                                                        onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                                        }}
                                                        format="DD-MM-YYYY" // Display format for user
                                                        // minDate={dayjs()}
                                                        maxDate={dayjs(watch('endDate'))}
                                                        slotProps={{
                                                        textField: {
                                                            error: !!error,
                                                            helperText: error?.message,
                                                            fullWidth: true,
                                                            required: true,
                                                            size: 'small',
                                                            inputProps: {
                                                            style: { fontSize: '.75rem' }
                                                            }
                                                        }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        {/* <DatePicker
                                            label="End Date"
                                            value={endDate}
                                            onChange={(newValue) => setEndDate(newValue)}
                                            slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                            minDate={startDate}
                                            maxDate={dayjs()}
                                        /> */}
                                        <Controller
                                            name="endDate"
                                            control={control}
                                            rules={{
                                                // validate: (value) => {
                                                // if (!value) return "This field is required";
                                                // const date = dayjs(value);
                                                // const today = dayjs().startOf('day');
                                                // const start = dayjs(watch('startDate'));
                                                // if (!date.isValid()) return "Invalid date";
                                                // if (date.isBefore(start)) return "End Date cannot be before Start Date";
                                                // // if (date.isAfter(today)) return "End Date cannot be in the future";
                                                // return true;
                                                // }
                                            }}
                                            render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        {...restField}
                                                        sx={{
                                                        '& . iconButton': {
                                                            padding: 0.5,
                                                            fontSize: '1rem'
                                                        }
                                                        }}
                                                        // disabled={!watch('services').length>0 || !watch('customer')}
                                                        value={value ? dayjs(value) : null}
                                                        onChange={(newValue) => {
                                                        // Store the date in YYYY-MM-DD format for database compatibility
                                                        onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                                        }}
                                                        format="DD-MM-YYYY" // Display format for user
                                                        minDate={dayjs(watch('startDate'))}
                                                        // maxDate={dayjs()}
                                                        slotProps={{
                                                        textField: {
                                                            error: !!error,
                                                            helperText: error?.message,
                                                            fullWidth: true,
                                                            required: true,
                                                            size: 'small',
                                                            inputProps: {
                                                            style: { fontSize: '.75rem' }
                                                            }
                                                        }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            )}
                                        />
                                    </Grid>
                                </>
                            )}
                            
                            {searchType === 'year' && (
                                <Grid item xs={12} sm={3}>
                                    {/* <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Select Year"
                                        value={year}
                                        onChange={(e) => setYear(e.target.value)}
                                    >
                                        {years.map((y) => (
                                            <MenuItem key={y} value={y}>
                                                FY {y} - {y + 1}
                                            </MenuItem>
                                        ))}
                                    </TextField> */}
                                    <Controller
                                        name="year"
                                        control={control}
                                        render={({ field }) => (
                                            <FormControl sx={{ minWidth: "100%" }} size="small">
                                                <Select
                                                    {...field}
                                                    sx={{
                                                        fontSize:'0.65rem',
                                                    }}
                                                >
                                                    {years.map((y) => (
                                                        <MenuItem key={y} value={y}>
                                                            FY {y} - {y + 1}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )}
                                    />
                                </Grid>
                            )}

                            {searchType === 'booking' && (
                                <Grid item xs={12} sm={3}>
                                    <Controller
                                        name="bookingNumber"
                                        control={control}
                                        rules={{
                                            // if searchtype is booking number then required
                                            validate: (value) => {
                                                if (searchType === 'bookingNumber' && !value) {
                                                    return "Booking Number is required";
                                                }
                                                return true;
                                            }
                                        }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                size="small"
                                                label="Booking Number"
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Search sx={{ fontSize: '0.75rem' }} />
                                                        </InputAdornment>
                                                    ),
                                                    inputProps: {
                                                        style: { fontSize: '0.65rem' }
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} sm={3} sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    type='submit'
                                    // onClick={fetchTaxData}
                                    disabled={loading || !isDirty}
                                    startIcon={<Search />}
                                    size="small"
                                >
                                    {loading ? <CircularProgress size={20} color="inherit" /> : 'Search'}
                                </Button>
                                {/* {(searchType === 'booking' || rows.length > 0) && ( */}
                                    <IconButton onClick={handleClear} size="small" title="Clear">
                                        <Clear />
                                    </IconButton>
                                {/* )} */}
                                
                            </Grid>
                        </Grid>
                        

                        
                        {/* <TextField
                        value={quickFilterText}
                        onChange={(event) => setQuickFilterText(event.target.value)}
                        placeholder="Quick Search ..."
                        size="small"
                        fullWidth
                        sx={{
                            '& .MuiOutlinedInput-root': {
                            paddingLeft: '0px',
                            }
                        }}
                        InputProps={{
                            inputProps: {
                            style: {
                                height: '0.6rem',
                                textTransform: 'uppercase',
                                fontSize: 'x-small'
                            },
                            },
                            startAdornment: (
                            <InputAdornment position="start">
                                <IconButton>
                                <Search sx={{fontSize:'x-small'}}/>
                                </IconButton>
                            </InputAdornment>
                            ),
                        }}
                        /> */}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {rows.length > 0 && (
                        <ExportAll taxData = {rows} searchType={searchType} bookingNumber={bookingNumber} startDate={startDate} endDate={endDate} year={year} />

                            // <Button
                            //     variant="outlined"
                            //     onClick={exportToExcel}
                            //     startIcon={<Download />}
                            //     size="small"
                            // >
                            //     Export
                            // </Button>
                        )}
                    </Box>
                </Box>
                <DataGrid
                    rows={rows.map((row, index) => ({ ...row, id: `${row?.bookingNumber}-${row?.serviceName}-${index}` }))}
                    columns={columns.map((col) => ({
                        ...col,
                        flex: col.flex || 1, // Ensure columns resize dynamically
                        minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
                    }))}
                    getRowId={(row) => row?.id}
                    rowCount={rows && rows.length > 0 ? rows.length : 0} // Use totalRecords from API response
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    
                    showFirstButton={true}
                    showLastButton={true}

                    disableMultiSort={true}
        
                    loading={loading}
                    // getRowClassName={(params) => {
                    //     return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    // }}
                    
                    disableColumnMenu
                    disableRowSelectionOnClick
                    // disableColumnFilter
                    // disableColumnSelector
                    disableDensitySelector
                    sortingOrder={['asc', 'desc']}
                    slots={{
                        // toolbar: GridToolbar,
                        loadingOverlay: Loading,
                        // Optionally use custom pagination
                        pagination: CustomPagination,
                    }}
                    // slotProps={{
                    //   toolbar: {
                    //     showQuickFilter: true,  
                    //   },
                    // }}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{   
                        minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                        "& .MuiDataGrid-root": {
                        overflowX: "auto",
                        },
                        // Hide default footer since we're using custom pagination
                        '& .MuiDataGrid-footerContainer': {
                        display: 'block'
                        },
                        '& .MuiDataGrid-row': {
                        '& .MuiDataGrid-cell': {
                            py:1
                        },
                        // Add styles for deleted rows
                        '&.deleted-row': {
                            backgroundColor: '#ffebee !important', // Light red background
                            '&:hover': {
                            backgroundColor: '#ffcdd2 !important', // Darker red on hover
                            }
                        }
                        },           
                        '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                        borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        height: 'fit-content',
                        minHeight:'0 !important',
                        height:'2rem',
                        bgcolor: '#1976d2',
                        color: 'white',
                        },
                        // '& .MuiDataGrid-columnHeader': {
                        //   borderLeft: '1px solid rgba(224, 224, 224, 1)',
                        //   '&:last-child': {
                        //     borderRight: 'none',
                        //   },
                        // },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            color: 'white'
                        },
                        
                    }}
                    />
                </Box>
            </Box>
        </Card>
        {summary && (
                <Card sx={{ mb: 2 }}>
                    <CardContent>
                        <Typography variant="h6" sx={{ mb: 2 }}>Summary</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Total Bookings</Typography>
                                    <Typography variant="h6">{summary.totalBookings}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Taxable Amount</Typography>
                                    <Typography variant="h6">₹{parseFloat(summary.totalTaxableAmount || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Coupon Discount</Typography>
                                    <Typography variant="h6">₹{parseFloat(summary.totalCouponDiscount || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Coin Discount</Typography>
                                    <Typography variant="h6">₹{parseFloat(summary.totalCoinDiscount || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Total CGST</Typography>
                                    <Typography variant="h6" color="primary">₹{parseFloat(summary.totalCgst || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Total SGST</Typography>
                                    <Typography variant="h6" color="primary">₹{parseFloat(summary.totalSgst || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#fff3e0', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Total IGST</Typography>
                                    <Typography variant="h6" sx={{ color: '#f57c00' }}>₹{parseFloat(summary.totalIgst || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={4} md={2}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e8f5e9', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Total GST</Typography>
                                    <Typography variant="h6" color="success.main">₹{parseFloat(summary.totalGst || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={4}>
                                <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#fce4ec', borderRadius: 1 }}>
                                    <Typography variant="caption" color="text.secondary">Grand Total</Typography>
                                    <Typography variant="h5" color="error.main">₹{parseFloat(summary.grandTotal || 0).toFixed(2)}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )}
    </>
  )
}

export default TaxReport
